import { render, staticRenderFns } from "./kpi-managers-record.vue?vue&type=template&id=1c91f15e"
import script from "./kpi-managers-record.vue?vue&type=script&lang=js"
export * from "./kpi-managers-record.vue?vue&type=script&lang=js"
import style0 from "./kpi-managers-record.vue?vue&type=style&index=0&id=1c91f15e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports